import React from "react";

const Column = ({
  children,
  className = "",
  align = "start",
  justify = "start",
  gap = "3",
  padding = "",
  fullHeight = false,
}) => {
  return (
    <div
      className={`flex flex-col gap-${gap} p-${padding} min-w-0 
        ${fullHeight ? "h-full" : "h-auto"} 
        items-${align} justify-${justify} ${className}`}
    >
      {children}
    </div>
  );
};

export default Column;